export const LOGIN_MFA_STEP = 'login mfa step'
export const SIGNUP_MFA_STEP = 'signup mfa step'
export const INDIVIDUAL_COMPLETE = 'complete individual verification'
export const CORPORATE_COMPLETE = 'complete corporate verification'
